import {
    ALL_YOUR_FAVES_UK_IE,
    API_HERITAGE_MONTH,
    ARTS_AND_CRAFTS_EVENTS_TO_BING_COLOR_INTO_YOUR_LIFE,
    AUSTRALIAS_FIRST_PEOPLES,
    BEST_EVENTS_TO_EXPERIENCE_IN_AUCKLAND,
    BEST_EVENTS_TO_EXPERIENCE_IN_BRISBANE,
    BEST_EVENTS_TO_EXPERIENCE_IN_MELBOURNE,
    BEST_EVENTS_TO_EXPERIENCE_IN_PERTH,
    BEST_EVENTS_TO_EXPERIENCE_IN_SYDNEY,
    BEST_UK_AND_IRELAND_EVENTS_URL,
    BLACK_HISTORY_AND_BEYOND,
    BLACK_HISTORY_MONTH_US_CA,
    BOSTON_ST_PATRICKS_DAY,
    BUMBLE_DATE_IDEAS_CHICAGO,
    BUMBLE_DATE_IDEAS_LONDON,
    BUMBLE_DATE_IDEAS_NYC,
    CHICAGO_CITY_EVENT_CALENDAR,
    CHICAGO_ST_PATRICKS_DAY,
    CONNECT_THROUGH_ONLINE_EVENTS,
    CORONATION_COLLECTION_LONDON,
    COWBOYCORE_COLLECTION_DL,
    COWBOYCORE_COLLECTION_HT,
    COWBOYCORE_COLLECTION_LA,
    COWBOYCORE_COLLECTION_SF,
    COZY_HOLIDAY_COLLECTION_DC,
    COZY_HOLIDAY_COLLECTION_LONDON,
    COZY_HOLIDAY_COLLECTION_NYC,
    DATING_COLLECTION_CHICAGO,
    DATING_COLLECTION_DC,
    DATING_COLLECTION_LA,
    DATING_COLLECTION_MIAMI,
    DATING_COLLECTION_SEATTLE,
    DC_ST_PATRICKS_DAY,
    DO_GOOD_VOLUNTEERING,
    EATER_NYC,
    EDUCATE_YOURSELF_ONLINE_RACIAL_EQUITY_WORKSHOPS,
    END_OF_SUMMER_CHI,
    END_OF_SUMMER_DC,
    END_OF_SUMMER_LONDON,
    END_OF_SUMMER_NYC,
    ENTERTAIMENT_TONIGHT,
    EVENTS_FOR_KIDS_WHILE_PARENTS_WORK_FROM_HOME,
    EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
    EVENTS_TO_ATTEND_WITHOUT_STEPPING_FOOT_OUTSIDE,
    EVENT_CALENDAR_2024_AT,
    EVENT_PLANNING_WEBINARS_US_CA_UK_IE_AU,
    FEEL_THE_LOVE_UK_IE,
    FESTIVE_EVENTS_UK_AND_IE,
    FITNESS_CLASSES_FOR_BREAKING_A_SWEAT_AT_HOME,
    FOOD_AND_DRINKS_EVENTS_TO_FEAST_ON_WHILE_RESTAURANTS_AND_BARS_ARE_CLOSED,
    GTFO_DATE_COLLECTION_CHI,
    GTFO_DATE_COLLECTION_DC,
    GTFO_DATE_COLLECTION_LA,
    GTFO_DATE_COLLECTION_LONDON,
    GTFO_DATE_COLLECTION_NYC,
    GTFO_DATE_COLLECTION_SF,
    GTFO_DATE_COLLECTION_US,
    GTFO_EAT_COLLECTION_CHI,
    GTFO_EAT_COLLECTION_DC,
    GTFO_EAT_COLLECTION_LA,
    GTFO_EAT_COLLECTION_LONDON,
    GTFO_EAT_COLLECTION_NYC,
    GTFO_EAT_COLLECTION_SF,
    HALLOWEEN_COLLECTION_ATLANTA1,
    HALLOWEEN_COLLECTION_ATLANTA2,
    HALLOWEEN_COLLECTION_BOSTON1,
    HALLOWEEN_COLLECTION_BOSTON2,
    HALLOWEEN_COLLECTION_CHI1,
    HALLOWEEN_COLLECTION_CHI2,
    HALLOWEEN_COLLECTION_DC1,
    HALLOWEEN_COLLECTION_DC2,
    HALLOWEEN_COLLECTION_HOUSTON1,
    HALLOWEEN_COLLECTION_HOUSTON2,
    HALLOWEEN_COLLECTION_LA1,
    HALLOWEEN_COLLECTION_LA2,
    HALLOWEEN_COLLECTION_LA3,
    HALLOWEEN_COLLECTION_LONDON1,
    HALLOWEEN_COLLECTION_LONDON2,
    HALLOWEEN_COLLECTION_MIAMI1,
    HALLOWEEN_COLLECTION_MIAMI2,
    HALLOWEEN_COLLECTION_NYC1,
    HALLOWEEN_COLLECTION_NYC2,
    HALLOWEEN_COLLECTION_NYC3,
    HALLOWEEN_COLLECTION_SF1,
    HALLOWEEN_COLLECTION_SF2,
    HALLOWEEN_COLLECTION_VIRTUAL,
    HOLIDAY_COLLECTION_BOSTON,
    HOLIDAY_COLLECTION_CHI,
    HOLIDAY_COLLECTION_DC,
    HOLIDAY_COLLECTION_LA,
    HOLIDAY_COLLECTION_LONDON,
    HOLIDAY_COLLECTION_MELBOURNE,
    HOLIDAY_COLLECTION_MIAMI,
    HOLIDAY_COLLECTION_NYC,
    HOLIDAY_COLLECTION_SF,
    HOLIDAY_COLLECTION_TORONTO,
    HOLIDAY_EVENTS_CHRISTMAS_HANUKKAH_KWANZAA,
    HOLIDAY_SEASON_COLLECTION_CHI,
    HOLIDAY_SEASON_COLLECTION_DC,
    HOLIDAY_SEASON_COLLECTION_LA,
    HOLIDAY_SEASON_COLLECTION_LONDON,
    HOLIDAY_SEASON_COLLECTION_NYC,
    HOLIDAY_SEASON_COLLECTION_SF,
    HOLIDAY_SEASON_COLLECTION_VIRTUAL,
    JULY_FOURTH_AT,
    JULY_FOURTH_BO,
    JULY_FOURTH_CHI,
    JULY_FOURTH_DC,
    JULY_FOURTH_DL,
    JULY_FOURTH_HO,
    JULY_FOURTH_LA,
    JULY_FOURTH_MI,
    JULY_FOURTH_NYC,
    JULY_FOURTH_SF,
    JULY_FOURTH_US,
    LA_ST_PATRICKS_DAY,
    LONDON_EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
    LONDON_EVENT_CALENDAR_UK,
    LONDON_ST_PATRICKS_DAY,
    LOS_ANGELES_EVENT_CALENDAR_US,
    MAGICAL_HOLIDAY_COLLECTION_BOSTON,
    MAGICAL_HOLIDAY_COLLECTION_CHI,
    MAGICAL_HOLIDAY_COLLECTION_DC,
    MAGICAL_HOLIDAY_COLLECTION_LA,
    MAGICAL_HOLIDAY_COLLECTION_LONDON,
    MAGICAL_HOLIDAY_COLLECTION_MELBOURNE,
    MAGICAL_HOLIDAY_COLLECTION_MIAMI,
    MAGICAL_HOLIDAY_COLLECTION_NYC,
    MAGICAL_HOLIDAY_COLLECTION_SF,
    MAGICAL_HOLIDAY_COLLECTION_TORONTO,
    MATCHMAKER_MARIA_NYC,
    MELBOURNE_JUNE13_COLLECTION,
    MENTAL_HEALTH_ACTION_DAY,
    MUSIC_EVENTS_TO_KEEP_YOU_DANCING_AT_HOME,
    MUSIC_FESTIVAL_CALENDAR,
    NEW_YORK_CITY_EVENT_CALENDAR,
    NEW_YORK_EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
    NEW_YORK_ST_PATRICKS_DAY,
    NYE_2024_BO,
    NYE_2024_CHI,
    NYE_2024_DC,
    NYE_2024_LA,
    NYE_2024_LDN,
    NYE_2024_MEL,
    NYE_2024_MI,
    NYE_2024_NYC,
    NYE_2024_SF,
    NYE_2024_TOR,
    NYE_CHILLERS_BO,
    NYE_CHILLERS_CHI,
    NYE_CHILLERS_DC,
    NYE_CHILLERS_LDN,
    NYE_CHILLERS_MEL,
    NYE_CHILLERS_MI,
    NYE_CHILLERS_NYC,
    NYE_CHILLERS_SF,
    NYE_CHILLERS_TOR,
    NY_FASHION_WEEK,
    ONLINE_THANKSGIVING_COOKING,
    OPEN_BAR_CHI,
    OPEN_BAR_DC,
    OPEN_BAR_LA,
    OPEN_BAR_MEL,
    OPEN_BAR_MI,
    OPEN_BAR_NYC,
    OPEN_BAR_SF,
    PAIGE_HANNAH_COLLECTION_US,
    PARK_UP_UK,
    PRIDE_2024_AT,
    PRIDE_2024_AU,
    PRIDE_2024_BA,
    PRIDE_2024_BO,
    PRIDE_2024_CL,
    PRIDE_2024_DE,
    PRIDE_2024_DL,
    PRIDE_2024_HO,
    PRIDE_2024_MI,
    PRIDE_2024_PH,
    PRIDE_2024_ST,
    PRIDE_2024_TA,
    PRIDE_2024_TO,
    PRIDE_2024_VC,
    PRIDE_CHICAGO_2023,
    PRIDE_DC_2023,
    PRIDE_LA_2023,
    QA_TEST_MADE_FOR_NYC_FOOD_LOVERS,
    QA_TEST_MISMATCHED_DATA,
    QA_TEST_MOCKED_COLLECTION_FOR_TESTING,
    QA_TEST_MOCKED_COLLECTION_FOR_TESTING2,
    REMIXER_NYC,
    SAN_FRANCISCO_EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
    SAN_FRANCISCO_EVENT_CALENDAR_US,
    SCARLETT_ST_CLAIR,
    SF_ST_PATRICKS_DAY,
    SMALL_BUSINESS_SATURDAY,
    SOCIAL_CONNECTION,
    STOP_ASIAN_HATE_US,
    SUMMER_FESTIVALS_LA,
    SYDNEY_JUNE13_COLLECTION,
    TAKE_CARE_OF_YOURSELF_AND_YOUR_COMMUNITY,
    TRICKS_AND_TREATS_VIRTUAL_HALLOWEEN_EVENTS_FOR_ALL_AGES,
    UK_FESTIVALS_2021,
    US_INTL_WOMENS_DAY,
    US_ST_PATRICKS_DAY,
    VALENTINES_DAY_CHI,
    VALENTINES_DAY_DC,
    VALENTINES_DAY_LA,
    VALENTINES_DAY_LONDON,
    VALENTINES_DAY_NYC,
    VALENTINES_DAY_NYC2,
    VALENTINES_DAY_SF,
    VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
    VIRTUAL_NEW_YEAR_EVENTS_2020,
    VIRTUAL_VALENTINE_US_CA,
    WASHINGTON_DC_CITY_EVENT_CALENDAR,
    WELLNESS_EVENTS_TO_KEEP_YOU_GROUNDED,
    WORLD_SURF_LEAGUE,
} from './collections';
import {
    TLD_AUSTRALIA,
    TLD_CANADA,
    TLD_IRELAND,
    TLD_NEW_ZEALAND,
    TLD_UNITED_KINGDOM,
    TLD_UNITED_STATES,
} from './tlds';

// Order in which collections should be shown on the carousel
export const PRIORITY_COLLECTIONS = [
    NYE_2024_BO,
    NYE_2024_CHI,
    NYE_2024_DC,
    NYE_2024_LA,
    NYE_2024_LDN,
    NYE_2024_MEL,
    NYE_2024_MI,
    NYE_2024_NYC,
    NYE_2024_SF,
    NYE_2024_TOR,
    OPEN_BAR_CHI,
    OPEN_BAR_DC,
    OPEN_BAR_LA,
    OPEN_BAR_MEL,
    OPEN_BAR_MI,
    OPEN_BAR_NYC,
    OPEN_BAR_SF,
    NYE_CHILLERS_BO,
    NYE_CHILLERS_CHI,
    NYE_CHILLERS_DC,
    NYE_CHILLERS_LDN,
    NYE_CHILLERS_MEL,
    NYE_CHILLERS_MI,
    NYE_CHILLERS_NYC,
    NYE_CHILLERS_SF,
    NYE_CHILLERS_TOR,
    HOLIDAY_COLLECTION_BOSTON,
    HOLIDAY_COLLECTION_CHI,
    HOLIDAY_COLLECTION_DC,
    HOLIDAY_COLLECTION_LA,
    HOLIDAY_COLLECTION_LONDON,
    HOLIDAY_COLLECTION_MELBOURNE,
    HOLIDAY_COLLECTION_MIAMI,
    HOLIDAY_COLLECTION_NYC,
    HOLIDAY_COLLECTION_SF,
    HOLIDAY_COLLECTION_TORONTO,
    MAGICAL_HOLIDAY_COLLECTION_BOSTON,
    MAGICAL_HOLIDAY_COLLECTION_CHI,
    MAGICAL_HOLIDAY_COLLECTION_DC,
    MAGICAL_HOLIDAY_COLLECTION_LA,
    MAGICAL_HOLIDAY_COLLECTION_LONDON,
    MAGICAL_HOLIDAY_COLLECTION_MELBOURNE,
    MAGICAL_HOLIDAY_COLLECTION_MIAMI,
    MAGICAL_HOLIDAY_COLLECTION_NYC,
    MAGICAL_HOLIDAY_COLLECTION_SF,
    MAGICAL_HOLIDAY_COLLECTION_TORONTO,
    COZY_HOLIDAY_COLLECTION_DC,
    COZY_HOLIDAY_COLLECTION_LONDON,
    COZY_HOLIDAY_COLLECTION_NYC,
    SMALL_BUSINESS_SATURDAY,
    DATING_COLLECTION_CHICAGO,
    DATING_COLLECTION_DC,
    DATING_COLLECTION_LA,
    DATING_COLLECTION_MIAMI,
    DATING_COLLECTION_SEATTLE,
    NEW_YORK_ST_PATRICKS_DAY,
    CHICAGO_ST_PATRICKS_DAY,
    LA_ST_PATRICKS_DAY,
    DC_ST_PATRICKS_DAY,
    BOSTON_ST_PATRICKS_DAY,
    SF_ST_PATRICKS_DAY,
    LONDON_ST_PATRICKS_DAY,
    VALENTINES_DAY_SF,
    VALENTINES_DAY_DC,
    VALENTINES_DAY_NYC2,
    PRIDE_2024_AT,
    PRIDE_2024_AU,
    PRIDE_2024_BA,
    PRIDE_2024_BO,
    PRIDE_2024_CL,
    PRIDE_2024_DE,
    PRIDE_2024_DL,
    PRIDE_2024_HO,
    PRIDE_2024_MI,
    PRIDE_2024_PH,
    PRIDE_2024_ST,
    PRIDE_2024_TA,
    PRIDE_2024_TO,
    PRIDE_2024_VC,
    JULY_FOURTH_AT,
    JULY_FOURTH_BO,
    JULY_FOURTH_CHI,
    JULY_FOURTH_DC,
    JULY_FOURTH_DL,
    JULY_FOURTH_HO,
    JULY_FOURTH_LA,
    JULY_FOURTH_MI,
    JULY_FOURTH_NYC,
    JULY_FOURTH_SF,
    JULY_FOURTH_US,
    EVENT_CALENDAR_2024_AT,
    WORLD_SURF_LEAGUE,
    PAIGE_HANNAH_COLLECTION_US,
    HALLOWEEN_COLLECTION_ATLANTA1,
    HALLOWEEN_COLLECTION_ATLANTA2,
    HALLOWEEN_COLLECTION_BOSTON1,
    HALLOWEEN_COLLECTION_BOSTON2,
    HALLOWEEN_COLLECTION_CHI1,
    HALLOWEEN_COLLECTION_CHI2,
    HALLOWEEN_COLLECTION_DC1,
    HALLOWEEN_COLLECTION_DC2,
    HALLOWEEN_COLLECTION_HOUSTON1,
    HALLOWEEN_COLLECTION_HOUSTON2,
    HALLOWEEN_COLLECTION_LA1,
    HALLOWEEN_COLLECTION_LA2,
    HALLOWEEN_COLLECTION_LA3,
    HALLOWEEN_COLLECTION_LONDON1,
    HALLOWEEN_COLLECTION_LONDON2,
    HALLOWEEN_COLLECTION_MIAMI1,
    HALLOWEEN_COLLECTION_MIAMI2,
    HALLOWEEN_COLLECTION_NYC1,
    HALLOWEEN_COLLECTION_NYC2,
    HALLOWEEN_COLLECTION_NYC3,
    HALLOWEEN_COLLECTION_SF1,
    HALLOWEEN_COLLECTION_SF2,
    SCARLETT_ST_CLAIR,
    API_HERITAGE_MONTH,
    COWBOYCORE_COLLECTION_DL,
    COWBOYCORE_COLLECTION_HT,
    COWBOYCORE_COLLECTION_LA,
    COWBOYCORE_COLLECTION_SF,
    MATCHMAKER_MARIA_NYC,
    GTFO_DATE_COLLECTION_CHI,
    GTFO_DATE_COLLECTION_DC,
    GTFO_DATE_COLLECTION_LA,
    GTFO_DATE_COLLECTION_LONDON,
    GTFO_DATE_COLLECTION_NYC,
    GTFO_DATE_COLLECTION_SF,
    GTFO_DATE_COLLECTION_US,
    PRIDE_DC_2023,
    PRIDE_CHICAGO_2023,
    PRIDE_LA_2023,
    CORONATION_COLLECTION_LONDON,
    END_OF_SUMMER_CHI,
    END_OF_SUMMER_DC,
    END_OF_SUMMER_NYC,
    END_OF_SUMMER_LONDON,
    GTFO_EAT_COLLECTION_CHI,
    GTFO_EAT_COLLECTION_DC,
    GTFO_EAT_COLLECTION_LA,
    GTFO_EAT_COLLECTION_LONDON,
    GTFO_EAT_COLLECTION_NYC,
    GTFO_EAT_COLLECTION_SF,
    SUMMER_FESTIVALS_LA,
    EATER_NYC,
    SOCIAL_CONNECTION,
    REMIXER_NYC,
    NEW_YORK_EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
    SAN_FRANCISCO_EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
    LONDON_EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
    NEW_YORK_CITY_EVENT_CALENDAR,
    CHICAGO_CITY_EVENT_CALENDAR,
    WASHINGTON_DC_CITY_EVENT_CALENDAR,
    LOS_ANGELES_EVENT_CALENDAR_US,
    SAN_FRANCISCO_EVENT_CALENDAR_US,
    LONDON_EVENT_CALENDAR_UK,
    DO_GOOD_VOLUNTEERING,
    MUSIC_FESTIVAL_CALENDAR,
];

export const COLLECTION_MAPPING = {
    [TLD_UNITED_STATES]: [
        HOLIDAY_COLLECTION_BOSTON,
        HOLIDAY_COLLECTION_CHI,
        HOLIDAY_COLLECTION_DC,
        HOLIDAY_COLLECTION_LA,
        HOLIDAY_COLLECTION_MIAMI,
        HOLIDAY_COLLECTION_NYC,
        HOLIDAY_COLLECTION_SF,
        MAGICAL_HOLIDAY_COLLECTION_BOSTON,
        MAGICAL_HOLIDAY_COLLECTION_CHI,
        MAGICAL_HOLIDAY_COLLECTION_DC,
        MAGICAL_HOLIDAY_COLLECTION_LA,
        MAGICAL_HOLIDAY_COLLECTION_MIAMI,
        MAGICAL_HOLIDAY_COLLECTION_NYC,
        MAGICAL_HOLIDAY_COLLECTION_SF,
        COZY_HOLIDAY_COLLECTION_DC,
        COZY_HOLIDAY_COLLECTION_NYC,
        SMALL_BUSINESS_SATURDAY,
        NEW_YORK_ST_PATRICKS_DAY,
        CHICAGO_ST_PATRICKS_DAY,
        LA_ST_PATRICKS_DAY,
        SF_ST_PATRICKS_DAY,
        DC_ST_PATRICKS_DAY,
        BOSTON_ST_PATRICKS_DAY,
        US_ST_PATRICKS_DAY,
        VALENTINES_DAY_SF,
        VALENTINES_DAY_DC,
        VALENTINES_DAY_NYC2,
        PRIDE_2024_AT,
        PRIDE_2024_AU,
        PRIDE_2024_BA,
        PRIDE_2024_BO,
        PRIDE_2024_CL,
        PRIDE_2024_DE,
        PRIDE_2024_DL,
        PRIDE_2024_HO,
        PRIDE_2024_MI,
        PRIDE_2024_PH,
        PRIDE_2024_ST,
        PRIDE_2024_TA,
        PRIDE_2024_TO,
        PRIDE_2024_VC,
        EVENT_CALENDAR_2024_AT,
        WORLD_SURF_LEAGUE,
        API_HERITAGE_MONTH,
        COWBOYCORE_COLLECTION_DL,
        COWBOYCORE_COLLECTION_HT,
        COWBOYCORE_COLLECTION_LA,
        COWBOYCORE_COLLECTION_SF,
        MATCHMAKER_MARIA_NYC,
        DO_GOOD_VOLUNTEERING,
        LONDON_EVENT_CALENDAR_UK,
        PAIGE_HANNAH_COLLECTION_US,
        NYE_2024_BO,
        NYE_2024_CHI,
        NYE_2024_DC,
        NYE_2024_LA,
        NYE_2024_MI,
        NYE_2024_NYC,
        NYE_2024_SF,
        NYE_CHILLERS_BO,
        NYE_CHILLERS_CHI,
        NYE_CHILLERS_DC,
        NYE_CHILLERS_MI,
        NYE_CHILLERS_NYC,
        NYE_CHILLERS_SF,
        OPEN_BAR_CHI,
        OPEN_BAR_DC,
        OPEN_BAR_LA,
        OPEN_BAR_MI,
        OPEN_BAR_NYC,
        OPEN_BAR_SF,
        HALLOWEEN_COLLECTION_ATLANTA1,
        HALLOWEEN_COLLECTION_ATLANTA2,
        HALLOWEEN_COLLECTION_BOSTON1,
        HALLOWEEN_COLLECTION_BOSTON2,
        HALLOWEEN_COLLECTION_CHI1,
        HALLOWEEN_COLLECTION_CHI2,
        HALLOWEEN_COLLECTION_DC1,
        HALLOWEEN_COLLECTION_DC2,
        HALLOWEEN_COLLECTION_HOUSTON1,
        HALLOWEEN_COLLECTION_HOUSTON2,
        HALLOWEEN_COLLECTION_LA1,
        HALLOWEEN_COLLECTION_LA2,
        HALLOWEEN_COLLECTION_LA3,
        HALLOWEEN_COLLECTION_MIAMI1,
        HALLOWEEN_COLLECTION_MIAMI2,
        HALLOWEEN_COLLECTION_NYC1,
        HALLOWEEN_COLLECTION_NYC2,
        HALLOWEEN_COLLECTION_NYC3,
        HALLOWEEN_COLLECTION_SF1,
        HALLOWEEN_COLLECTION_SF2,
        SCARLETT_ST_CLAIR,
        GTFO_DATE_COLLECTION_CHI,
        GTFO_DATE_COLLECTION_DC,
        GTFO_DATE_COLLECTION_LA,
        GTFO_DATE_COLLECTION_NYC,
        GTFO_DATE_COLLECTION_SF,
        GTFO_DATE_COLLECTION_US,
        BUMBLE_DATE_IDEAS_NYC,
        BUMBLE_DATE_IDEAS_CHICAGO,
        END_OF_SUMMER_CHI,
        END_OF_SUMMER_DC,
        END_OF_SUMMER_NYC,
        GTFO_EAT_COLLECTION_CHI,
        GTFO_EAT_COLLECTION_DC,
        GTFO_EAT_COLLECTION_LA,
        GTFO_EAT_COLLECTION_NYC,
        GTFO_EAT_COLLECTION_SF,
        JULY_FOURTH_AT,
        JULY_FOURTH_BO,
        JULY_FOURTH_CHI,
        JULY_FOURTH_DC,
        JULY_FOURTH_DL,
        JULY_FOURTH_HO,
        JULY_FOURTH_LA,
        JULY_FOURTH_MI,
        JULY_FOURTH_NYC,
        JULY_FOURTH_SF,
        JULY_FOURTH_US,
        NY_FASHION_WEEK,
        SUMMER_FESTIVALS_LA,
        PRIDE_DC_2023,
        PRIDE_CHICAGO_2023,
        PRIDE_LA_2023,
        EATER_NYC,
        MENTAL_HEALTH_ACTION_DAY,
        VALENTINES_DAY_CHI,
        VALENTINES_DAY_LA,
        VALENTINES_DAY_NYC,
        HOLIDAY_SEASON_COLLECTION_CHI,
        HOLIDAY_SEASON_COLLECTION_DC,
        HOLIDAY_SEASON_COLLECTION_LA,
        HOLIDAY_SEASON_COLLECTION_NYC,
        HOLIDAY_SEASON_COLLECTION_SF,
        HOLIDAY_SEASON_COLLECTION_VIRTUAL,
        HALLOWEEN_COLLECTION_VIRTUAL,
        SOCIAL_CONNECTION,
        REMIXER_NYC,
        NEW_YORK_EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
        SAN_FRANCISCO_EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
        US_INTL_WOMENS_DAY,
        EVENTS_TO_ATTEND_WITHOUT_STEPPING_FOOT_OUTSIDE,
        MUSIC_EVENTS_TO_KEEP_YOU_DANCING_AT_HOME,
        WELLNESS_EVENTS_TO_KEEP_YOU_GROUNDED,
        EVENTS_FOR_KIDS_WHILE_PARENTS_WORK_FROM_HOME,
        FOOD_AND_DRINKS_EVENTS_TO_FEAST_ON_WHILE_RESTAURANTS_AND_BARS_ARE_CLOSED,
        FITNESS_CLASSES_FOR_BREAKING_A_SWEAT_AT_HOME,
        EDUCATE_YOURSELF_ONLINE_RACIAL_EQUITY_WORKSHOPS,
        QA_TEST_MADE_FOR_NYC_FOOD_LOVERS,
        QA_TEST_MOCKED_COLLECTION_FOR_TESTING,
        QA_TEST_MOCKED_COLLECTION_FOR_TESTING2,
        ONLINE_THANKSGIVING_COOKING,
        HOLIDAY_EVENTS_CHRISTMAS_HANUKKAH_KWANZAA,
        VIRTUAL_NEW_YEAR_EVENTS_2020,
        TAKE_CARE_OF_YOURSELF_AND_YOUR_COMMUNITY,
        VIRTUAL_VALENTINE_US_CA,
        BLACK_HISTORY_MONTH_US_CA,
        EVENT_PLANNING_WEBINARS_US_CA_UK_IE_AU,
        STOP_ASIAN_HATE_US,
        VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
        LOS_ANGELES_EVENT_CALENDAR_US,
        SAN_FRANCISCO_EVENT_CALENDAR_US,
        EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
        NEW_YORK_CITY_EVENT_CALENDAR,
        CHICAGO_CITY_EVENT_CALENDAR,
        WASHINGTON_DC_CITY_EVENT_CALENDAR,
        MUSIC_FESTIVAL_CALENDAR,
        QA_TEST_MISMATCHED_DATA,
        DATING_COLLECTION_CHICAGO,
        DATING_COLLECTION_DC,
        DATING_COLLECTION_LA,
        DATING_COLLECTION_MIAMI,
        DATING_COLLECTION_SEATTLE,
    ],
    [TLD_CANADA]: [
        NYE_2024_TOR,
        NYE_CHILLERS_TOR,
        HOLIDAY_COLLECTION_TORONTO,
        MAGICAL_HOLIDAY_COLLECTION_TORONTO,
        PRIDE_2024_TO,
        PRIDE_2024_VC,
        EVENTS_TO_ATTEND_WITHOUT_STEPPING_FOOT_OUTSIDE,
        MUSIC_EVENTS_TO_KEEP_YOU_DANCING_AT_HOME,
        WELLNESS_EVENTS_TO_KEEP_YOU_GROUNDED,
        EVENTS_FOR_KIDS_WHILE_PARENTS_WORK_FROM_HOME,
        ARTS_AND_CRAFTS_EVENTS_TO_BING_COLOR_INTO_YOUR_LIFE,
        FOOD_AND_DRINKS_EVENTS_TO_FEAST_ON_WHILE_RESTAURANTS_AND_BARS_ARE_CLOSED,
        FITNESS_CLASSES_FOR_BREAKING_A_SWEAT_AT_HOME,
        EDUCATE_YOURSELF_ONLINE_RACIAL_EQUITY_WORKSHOPS,
        QA_TEST_MADE_FOR_NYC_FOOD_LOVERS,
        ENTERTAIMENT_TONIGHT,
        TAKE_CARE_OF_YOURSELF_AND_YOUR_COMMUNITY,
        VIRTUAL_VALENTINE_US_CA,
        LONDON_EVENT_CALENDAR_UK,
        BLACK_HISTORY_MONTH_US_CA,
        EVENT_PLANNING_WEBINARS_US_CA_UK_IE_AU,
        VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
        EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
    ],
    [TLD_UNITED_KINGDOM]: [
        HOLIDAY_COLLECTION_LONDON,
        MAGICAL_HOLIDAY_COLLECTION_LONDON,
        COZY_HOLIDAY_COLLECTION_LONDON,
        NYE_2024_LDN,
        NYE_CHILLERS_LDN,
        GTFO_DATE_COLLECTION_LONDON,
        BUMBLE_DATE_IDEAS_LONDON,
        END_OF_SUMMER_LONDON,
        GTFO_EAT_COLLECTION_LONDON,
        CORONATION_COLLECTION_LONDON,
        LONDON_ST_PATRICKS_DAY,
        VALENTINES_DAY_LONDON,
        HOLIDAY_SEASON_COLLECTION_LONDON,
        HALLOWEEN_COLLECTION_LONDON1,
        HALLOWEEN_COLLECTION_LONDON2,
        LONDON_EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
        BLACK_HISTORY_AND_BEYOND,
        FESTIVE_EVENTS_UK_AND_IE,
        BEST_UK_AND_IRELAND_EVENTS_URL,
        TAKE_CARE_OF_YOURSELF_AND_YOUR_COMMUNITY,
        FEEL_THE_LOVE_UK_IE,
        UK_FESTIVALS_2021,
        PARK_UP_UK,
        ALL_YOUR_FAVES_UK_IE,
        VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
        LONDON_EVENT_CALENDAR_UK,
        EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
    ],
    [TLD_IRELAND]: [
        FESTIVE_EVENTS_UK_AND_IE,
        BEST_UK_AND_IRELAND_EVENTS_URL,
        TAKE_CARE_OF_YOURSELF_AND_YOUR_COMMUNITY,
        FEEL_THE_LOVE_UK_IE,
        VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
        LONDON_EVENT_CALENDAR_UK,
        EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
    ],
    [TLD_AUSTRALIA]: [
        NYE_2024_MEL,
        NYE_CHILLERS_MEL,
        OPEN_BAR_MEL,
        HOLIDAY_COLLECTION_MELBOURNE,
        MAGICAL_HOLIDAY_COLLECTION_MELBOURNE,
        SYDNEY_JUNE13_COLLECTION,
        MELBOURNE_JUNE13_COLLECTION,
        AUSTRALIAS_FIRST_PEOPLES,
        BEST_EVENTS_TO_EXPERIENCE_IN_BRISBANE,
        BEST_EVENTS_TO_EXPERIENCE_IN_PERTH,
        CONNECT_THROUGH_ONLINE_EVENTS,
        EVENT_PLANNING_WEBINARS_US_CA_UK_IE_AU,
        BEST_EVENTS_TO_EXPERIENCE_IN_MELBOURNE,
        BEST_EVENTS_TO_EXPERIENCE_IN_SYDNEY,
        ALL_YOUR_FAVES_UK_IE,
        VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
        LONDON_EVENT_CALENDAR_UK,
        TRICKS_AND_TREATS_VIRTUAL_HALLOWEEN_EVENTS_FOR_ALL_AGES,
    ],
    [TLD_NEW_ZEALAND]: [
        BEST_EVENTS_TO_EXPERIENCE_IN_AUCKLAND,
        VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
        TRICKS_AND_TREATS_VIRTUAL_HALLOWEEN_EVENTS_FOR_ALL_AGES,
    ],
};
